import { API_URL } from "../constants";
import { getHeaders, formatAmount, unFormatAmount } from "../utils";

export const getPropertyUnits = async (propertyId) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );
  return response.json();
};

export const getPropertyUnit = async (propertyId, unitId) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units/${unitId}`,
    {
      method: "GET",
      //headers: getHeaders(),
    }
  );
  return response.json();
};

export const addPropertyUnit = async (propertyId, payload) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units`,
    {
      method: "POST",
      body: JSON.stringify(payload),
      headers: getHeaders(),
    }
  );
  return response.json();
};

export const updatePropertyUnit = async (propertyId, unitId, payload) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units/${unitId}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: getHeaders(),
    }
  );
  return response.json();
};

export const getPropertyUnitLeaseSettings = async (propertyId, unitId) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units/${unitId}/lease-settings`,
    {
      method: "GET",
      //headers: getHeaders(),
    }
  );
  let result;
  await response.json().then((data) => {
    result = {
      ...data,
      rate: {
        ...data.rate,
        amount: unFormatAmount(data.rate.amount),
      },
      lateFee: {
        ...data.lateFee,
        amount: unFormatAmount(data.lateFee.amount),
      },
      securityDeposit: {
        ...data.securityDeposit,
        amount: unFormatAmount(data.securityDeposit.amount),
      },
    };
  });

  return new Promise((resolve) => {
    resolve(result);
  });
};

export const updatePropertyUnitLeaseSettings = async (
  propertyId,
  unitId,
  payload
) => {
  const updatedPayload = {
    ...payload,
    rate: {
      ...payload.rate,
      amount: formatAmount(payload.rate.amount),
    },
    lateFee: {
      ...payload.lateFee,
      amount: formatAmount(payload.lateFee.amount),
    },
    securityDeposit: {
      ...payload.securityDeposit,
      amount: formatAmount(payload.securityDeposit.amount),
    },
  };
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units/${unitId}/lease-settings`,
    {
      method: "PUT",
      body: JSON.stringify(updatedPayload),
      headers: getHeaders(),
    }
  );
  return response.json();
};
